<template>
  <pt-customer-table class="pt-customer-table__withData" @getTableData="getTableData" :tableData="tableData" :tableLabels="tableLabels" :totalNumber="totalNumber"
  ref="table" v-loading="loading" :isOutside="isOutside">
      <slot/>
  </pt-customer-table>
</template>

<script>
import PtCustomerTable from './index'
export default {
  name: 'pt-customer-table__withData',
  components: {
    'pt-customer-table': PtCustomerTable
  },
  props: {
    pageSize: {
      type: Number,
      default: 10
    },
    paramsData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    tableLabels: {
      type: Array,
      default: function () {
        return []
      }
    },
    isFromRouter: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      tableData: [],
      totalNumber: 0,
      loading: false,
      isOutside: false
    }
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        if (this.isFromRouter) {
        //   this.getTableData(0)
          this.isOutside = true
          this.getTableData(this.page)
        } else {
          this.resetPage()
        }
      }
    }
  },
  methods: {
    resetPage () {
      this.$refs.table.resetPage()
    },
    getTableData (page, next, size) {
      let data = {
        ...this.paramsData,
        pageable: {
          page: page,
          size: size || this.pageSize,
          sort: 'lastLoginTime,desc'
        }
      }
      if (!next) {
        this.loading = true
      }
      this.$store.dispatch('getMallUser', data).then(res => {
        if (next) {
          next(res.data)
        }
        this.loading = false
        this.tableData = res.data
        this.totalNumber = res.totalNumber
      }).catch(err => {
        this.loading = false
        this.$nextTick(_ => {
          this.$refs.table.showReTry()
        })
        this.$message.error(err || '获取用户列表失败')
      })
    }
  }
}
</script>
